/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FindAssetCustomFieldValueResponseDto
 */
export interface FindAssetCustomFieldValueResponseDto {
    /**
     * 
     * @type {string}
     * @memberof FindAssetCustomFieldValueResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FindAssetCustomFieldValueResponseDto
     */
    assetCustomFieldId: string;
    /**
     * 
     * @type {string}
     * @memberof FindAssetCustomFieldValueResponseDto
     */
    assetId: string;
    /**
     * 
     * @type {string}
     * @memberof FindAssetCustomFieldValueResponseDto
     */
    value: string | null;
}

/**
 * Check if a given object implements the FindAssetCustomFieldValueResponseDto interface.
 */
export function instanceOfFindAssetCustomFieldValueResponseDto(value: object): value is FindAssetCustomFieldValueResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('assetCustomFieldId' in value) || value['assetCustomFieldId'] === undefined) return false;
    if (!('assetId' in value) || value['assetId'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function FindAssetCustomFieldValueResponseDtoFromJSON(json: any): FindAssetCustomFieldValueResponseDto {
    return FindAssetCustomFieldValueResponseDtoFromJSONTyped(json, false);
}

export function FindAssetCustomFieldValueResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAssetCustomFieldValueResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'assetCustomFieldId': json['assetCustomFieldId'],
        'assetId': json['assetId'],
        'value': json['value'],
    };
}

export function FindAssetCustomFieldValueResponseDtoToJSON(json: any): FindAssetCustomFieldValueResponseDto {
    return FindAssetCustomFieldValueResponseDtoToJSONTyped(json, false);
}

export function FindAssetCustomFieldValueResponseDtoToJSONTyped(value?: FindAssetCustomFieldValueResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'assetCustomFieldId': value['assetCustomFieldId'],
        'assetId': value['assetId'],
        'value': value['value'],
    };
}

